module.exports = __webpack_public_path__ + "img/12.55feef4d.jpg";